module.exports = __webpack_public_path__ + "img/9248_cacao.1b424d2b.jpg";